<app-stat-card
  titleKey="liveDashboard.qualitaet.schritte.title"
  subtitleKey="liveDashboard.qualitaet.schritte.subtitle"
  sectionLabelKey="liveDashboard.qualitaet.schritte.distribution"
  [stats]="stats()"
>
  @if (bars().length === 0) {
    <p class="testschritte-stats__empty">{{ 'liveDashboard.qualitaet.schritte.empty' | translate }}</p>
  } @else {
    <ul class="testschritte-stats__list">
      @for (bar of bars(); track bar.labelKey) {
        <li
          class="testschritte-stats__item"
          [attr.aria-label]="
            'liveDashboard.qualitaet.schritte.barAria' | translate: { type: bar.labelKey | translate, count: bar.count }
          "
        >
          <div class="testschritte-stats__head" aria-hidden="true">
            <span class="testschritte-stats__label">{{ bar.labelKey | translate }}</span>
            <span class="testschritte-stats__count">{{ bar.count }}</span>
          </div>
          <div class="testschritte-stats__track" aria-hidden="true">
            <div
              class="testschritte-stats__fill"
              [style.width]="bar.width"
              [style.background]="'var(' + bar.colorVar + ')'"
            ></div>
          </div>
        </li>
      }
    </ul>
  }
</app-stat-card>
